module.exports = __webpack_public_path__ + "static/media/Fr.Jinu.bad32756.png";